import { render } from "preact";
import { App } from "./app";
import { registerServiceWorker } from "./lib/register-sw";
import { startSyncDrainer } from "./lib/sync-drainer";
import { startBuildVersionWatcher } from "./lib/build-version";
import "./styles/tokens.css";

render(<App />, document.getElementById("root")!);

// Kick off SW registration AFTER the first render so we don't compete
// with the initial paint. The plugin is a no-op in dev, so this only
// matters for the production build.
if (import.meta.env.PROD) {
  registerServiceWorker();
  // Build-version watcher — independent of the SW. Polls
  // /api/build-info on focus + every 5 min and reloads on mismatch.
  // Covers the case where the SW updates but the in-memory app
  // doesn't (stale React tree on an installed PWA). One watcher
  // here covers every surface (login, kid PIN picker, kid app,
  // adult shell) because they all live under <App />.
  startBuildVersionWatcher();
}

// Sync drainer runs in dev too — easier to validate the offline →
// online queue replay without a full build/deploy cycle.
startSyncDrainer();
